<template>
  <svg
    class="custom-icon"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="rgb(var(--v-theme-primary))" />
    <path
      d="M10.8271 7.60352V15H9.17285V7.60352H10.8271ZM9.06348 5.66211C9.06348 5.41146 9.14551 5.2041 9.30957 5.04004C9.47819 4.87142 9.71061 4.78711 10.0068 4.78711C10.2985 4.78711 10.5286 4.87142 10.6973 5.04004C10.8659 5.2041 10.9502 5.41146 10.9502 5.66211C10.9502 5.9082 10.8659 6.11328 10.6973 6.27734C10.5286 6.44141 10.2985 6.52344 10.0068 6.52344C9.71061 6.52344 9.47819 6.44141 9.30957 6.27734C9.14551 6.11328 9.06348 5.9082 9.06348 5.66211Z"
    />
  </svg>
</template>
